import type { ReactNode } from "react";
import { Nav } from "./Nav";
import { Footer } from "./Footer";
import { DeferredChatWidget } from "./DeferredChatWidget";
import { UrgencyBanner } from "./UrgencyBanner";

export function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col">
      <UrgencyBanner />
      <Nav />
      <main className="flex-1">{children}</main>
      <Footer />
      <DeferredChatWidget />
    </div>
  );
}

